module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5KeJV"))).then(() => module.bundle.root('hEqeo'));